/* eslint-disable react/prop-types */
import React from "react"
import {
  Cpu,
  Home,
  Layers,
  MessageCircle,
  Server,
  Shield,
  UploadCloud,
  User,
  Users,
  Zap,
  File,
  Calendar,
  Airplay,
  BarChart2,
  HelpCircle,
  PieChart,
  CreditCard
} from "react-feather"

const NavIcon = ({ items }) => {
  const getIcon = () => {
    switch (items.icon) {
      case "User":
        return <User size={15} color="#1856b4"/>
      case "Users":
        return <Users size={15} color="#1856b4"/>
      case "Home":
        return <Home size={15} color="#1856b4" />
      case "Cpu":
        return <Cpu size={15} color="#1856b4" />
      case "UploadCloud":
        return <UploadCloud size={15} color="#1856b4" />
      case "Zap":
        return <Zap size={15} color="#1856b4" />
      case "Shield":
        return <Shield size={15} color="#1856b4" />
      case "MessageCircle":
        return <MessageCircle size={15} color="#1856b4" />
      case "Server":
        return <Server size={15} color="#1856b4" />
      case "Layers":
        return <Layers size={15} color="#1856b4" />
      case "Calendar":
        return <Calendar size={15} color="#1856b4" />
      case "File":
        return <File size={15} color="#1856b4"/>
      case "ReportsIcon":
        return <File size={15} color="#1856b4"/>
      case "Airplay":
        return <Airplay size={15} color="#1856b4"/>
      case "BarChart2":
        return <BarChart2 size={15} color="#1856b4"/>
      case "HelpCircle":
        return <HelpCircle size={15} color="#1856b4"/>
      case "PieChart":
        return <PieChart size={15} color="#1856b4"/>
      case "CreditCard":
        return <CreditCard size={15} color="#1856b4"/>
      default:
        return <User />
    }
  }

  let navIcons = false
  if (items.icon) {
    navIcons = <span className="pcoded-micon">{getIcon()}</span>
  }

  return <React.Fragment>{navIcons}</React.Fragment>
}

export default NavIcon
